module.exports = __webpack_public_path__ + "static/media/parthners.d193dfb8.svg";